<template>
  <div>
    <el-table :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column label="所属车场" align="center">
        <template slot-scope="scope">{{ scope.row.parkingName || '-' }}</template>
      </el-table-column>
      <el-table-column label="车位编号" align="center">
        <template slot-scope="scope">{{ scope.row.parkingSpaceName || '-' }}</template>
      </el-table-column>
      <el-table-column label="收费科目" align="center">
        <template slot-scope="scope">{{ scope.row.itemName || '-' }}</template>
      </el-table-column>
      <el-table-column label="应收金额" align="center">
        <template slot-scope="scope">{{ keepTwoDecimal(scope.row.orderAmount) }}</template>
      </el-table-column>
      <el-table-column label="费用说明" align="center">
        <template slot-scope="scope">
          {{ scope.row.feeDescription || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="欠费时长" align="center">
        <template slot-scope="scope">{{ scope.row.overdueTime || '-' }}天</template>
      </el-table-column>
      <el-table-column label="订单生成时间" align="center">
        <template slot-scope="scope">
          {{ cutTime(scope.row.createTime, ' ') }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="detail(scope.row)">详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pt-30"
      layout="total, prev, pager, next, jumper,sizes"
      background
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { orderCarSpaceCustomPage } from '@/api/finance'

export default {
  inject: ['indexThis'],
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.orderCustomList()
    },
    async orderCustomList() {
      const { data: res } = await orderCarSpaceCustomPage({
        buildingRoomId: this.indexThis.buildingRoomId,
        ...this.page,
        orderStatus: 0,
      })
      this.tableData = res.orderList || []
      this.total = Number(res.total) || 0
    },
    detail(value) {
      this.indexThis.$refs.CardParkSpaceUnPayOrderDetail.editForm = cloneDeep(value)
      this.indexThis.$refs.CardParkSpaceUnPayOrderDetail.drawer = true
    },
    sizeChange() {
      this.orderCustomList()
    },
    currentChange(e) {
      if (this.page.pageNo === e) return
      this.page.pageNo = e
      this.orderCustomList()
    },
  },
}
</script>
